import { Button } from '@ibsys/kit';
import { ArrowLeft } from 'lucide-react';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { DialogDataSection } from '@/features/DialogDataSection';
import { DialogSessionRoot } from '@/features/DialogSession';
import { DialogTranscriptSection } from '@/features/DialogTranscriptSection';
import { useAppNavigate } from '@/shared/lib';

export const SampleDialogPage: FC = () => {
  const { t } = useTranslation(['samples', 'common']);
  const { sampleId, dialogId } = useParams<{ sampleId: string; dialogId: string }>();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') ?? undefined;
  const location = useLocation();
  const navigate = useAppNavigate();

  const handleBackToSample = () => {
    navigate('/samples/:id', { id: sampleId ?? '' });
  };

  const handleTabChange = useCallback(
    (newTab: string) => {
      // Прочие query-параметры и секция атрибутов из hash сохраняются — меняется только активный таб.
      navigate(
        '/samples/:sampleId/dialog/:dialogId',
        { sampleId: sampleId ?? null, dialogId: dialogId ?? null },
        { query: { tab: newTab }, saveParams: true, hash: location.hash, replace: true },
      );
    },
    [sampleId, dialogId, navigate, location.hash],
  );

  if (!dialogId) {
    return null;
  }

  return (
    // Секции диалога рассчитывают на контекст записи и сессии: без него транскрипт с доступной
    // записью роняет страницу, а переходы к фрагменту по времени не работают.
    <DialogSessionRoot dialogId={dialogId} key={dialogId}>
      <div className="flex flex-col h-full gap-4">
        <div className="flex items-center gap-4">
          <Button variant="link" icon={<ArrowLeft />} onClick={handleBackToSample}>
            {t('samples:backToSample')}
          </Button>
        </div>
        <div className="flex flex-1 gap-6 overflow-hidden">
          <div className="flex-1 overflow-hidden">
            <DialogDataSection dialogId={+dialogId} hideBackButton activeTab={tab} onTabChange={handleTabChange} />
          </div>
          <div className="w-96 overflow-hidden">
            <DialogTranscriptSection dialogId={+dialogId} />
          </div>
        </div>
      </div>
    </DialogSessionRoot>
  );
};
